import { FunctionComponent, useEffect, useMemo, useState } from 'react'

import { IQuery } from 'modules/HomesForSale/types'

import MoreFiltersMobileSheet from '../MobileSheets/MoreFiltersMobileSheet'
import { IBathProps, IBedProps, IForSaleTypeProps, IMobileSheetProps } from '../types'
import FilterButton from './Shared/FilterButton'

interface IProps {
  forSaleTypeProps: IForSaleTypeProps
  bedProps: IBedProps
  bathProps: IBathProps
  applyFiltersForKeys: (keys: (keyof IQuery)[]) => void
  resetFiltersForKeys: (keys: (keyof IQuery)[]) => void
  hide?: boolean
}

const MoreFilters: FunctionComponent<IProps & IMobileSheetProps> = ({
  hide,
  forSaleTypeProps,
  bedProps,
  bathProps,
  applyFiltersForKeys,
  resetFiltersForKeys,
  ...mobileFilterSheetProps
}) => {
  const [applied, setApplied] = useState(false)

  const [label, setLabel] = useState('More Filters')

  const appliedFilterCount = useMemo(() => {
    if (!applied) return 0

    let count = 0

    const { selectedForSaleTypes } = forSaleTypeProps
    if (selectedForSaleTypes.length) count += 1

    const { selectedBedRange } = bedProps
    if (selectedBedRange.min || selectedBedRange.max) count += 1

    const { selectedBathRange } = bathProps
    if (selectedBathRange.min || selectedBathRange.max) count += 1

    return count
  }, [applied, forSaleTypeProps.selectedForSaleTypes])

  useEffect(() => {
    if (!appliedFilterCount) return setLabel('More Filters')

    setLabel(`More Filters: ${appliedFilterCount}`)
  }, [appliedFilterCount])

  const clearSelection = () => {
    resetFiltersForKeys(['forSaleTypes', 'bedsMin', 'bedsMax', 'bathsMin', 'bathsMax'])
    setApplied(false)
    setLabel('More Filters')
  }

  const handleApply = () => {
    applyFiltersForKeys(['forSaleTypes', 'bedsMin', 'bedsMax', 'bathsMin', 'bathsMax'])
    setApplied(true)
  }

  return (
    <>
      <FilterButton
        active={applied}
        label={label}
        onClearSelection={clearSelection}
        clearable={applied}
        onClick={mobileFilterSheetProps.showMobileFilterSheet}
        hide={hide}
      />
      <MoreFiltersMobileSheet
        onApply={handleApply}
        onReset={clearSelection}
        forSaleTypeProps={forSaleTypeProps}
        bedProps={bedProps}
        bathProps={bathProps}
        {...mobileFilterSheetProps}
      />
    </>
  )
}

export default MoreFilters
